export class Dictionary<TKey> {
  id: TKey;
  name: string;
}
